import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppConfig } from 'src/app/core/_config/app.config';
import { Observable } from 'rxjs';
import { BugInputModel } from '../models/bugInputModel';

@Injectable({
    providedIn: 'root',
})
export class BugsService {
    private API_URL = this.config.urlApi + this.config.versionApi;
    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    constructor(private http: HttpClient, private config: AppConfig) {}

    generateFileProcess(params: BugInputModel): Observable<any> {
        return this.http.put(`${this.API_URL}Manage/Bug/GenerateProcess`, params);
    }

    getErrorItemsLegalEntity(params: any): Observable<any> {
        return this.http.get(`${this.API_URL}Manage/Bug/Itens`, { params: params });
    }
}
